import React from "react";
import warning from "../../../../../../images/new-images/delete-warning.png";
import "./DeleleModal.css";

const DeleteModal = (props) => {
  return (
    <div className="Delete-modal">
      <div className="warning">
        <h5 className="Are-you-sure">Are you sure?</h5>
        <img className="warning-img" src={warning} />
      </div>
      <p className="confirm-text">
        Do you really want to delete
        <span className="email">{props.respondentEmail}</span>? This action
        cannot be undone.
      </p>
      <div className="buttons">
        <button onClick={props.handleModalClose} className="cancel-button">
          CANCEL
        </button>
        <button
          onClick={() =>
            props.handleDeleteRequest(
              props.respondantUserAssessmentId,
              props.respondantIndividualId
            )
          }
          className="delete-button"
        >
          YES, DELETE
        </button>
      </div>
    </div>
  );
};

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/new/Components/Invitations/Sent/Invitation-Modal/Delete-Modal/DeleteModal.jsx